import { Badge } from "@/components/ui/badge";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Building, Clock, MapPin, Banknote } from "lucide-react";

interface JobHeaderProps {
  title: string;
  company: string;
  location: string;
  working_hours: string;
  facility_type: string;
  contract_type?: string;
  salary_min?: number;
  salary_max?: number;
  getFacilityTypeLabel: (type: string) => string;
  getWorkingHoursLabel: (type: string) => string;
  getContractTypeLabel: (type: string) => string;
}

export function JobHeader({
  title,
  company,
  location,
  working_hours,
  facility_type,
  contract_type,
  salary_min,
  salary_max,
  getFacilityTypeLabel,
  getWorkingHoursLabel,
  getContractTypeLabel
}: JobHeaderProps) {
  return (
    <CardHeader>
      <div className="flex flex-col md:flex-row items-start justify-between gap-4">
        <div>
          <CardTitle className="text-xl">{title}</CardTitle>
          <CardDescription className="flex flex-wrap items-center gap-4 mt-2 text-gray-600">
            <span className="flex items-center gap-1">
              <Building className="h-4 w-4" />
              {company}
            </span>
            <span className="flex items-center gap-1">
              <MapPin className="h-4 w-4" />
              {location}
            </span>
            <span className="flex items-center gap-1">
              <Clock className="h-4 w-4" />
              {getWorkingHoursLabel(working_hours)}
            </span>
          </CardDescription>
        </div>
        <div className="flex flex-wrap gap-2">
          {salary_min && salary_max && (
            <Badge
              variant="default"
              className="bg-green-600 hover:bg-green-700 text-white text-sm py-1 px-3"
            >
              <Banknote className="h-4 w-4 mr-2" />€
              {salary_min.toLocaleString()} - €{salary_max.toLocaleString()}
            </Badge>
          )}
          <Badge variant="secondary">
            {getFacilityTypeLabel(facility_type)}
          </Badge>
          <Badge variant="outline">{getWorkingHoursLabel(working_hours)}</Badge>
          {contract_type && (
            <Badge variant="outline">
              {getContractTypeLabel(contract_type)}
            </Badge>
          )}
        </div>
      </div>
    </CardHeader>
  );
}
